import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

export type BreadcrumbDropdownProps = {
  items: MenuItemType[];
  label: JSX.Element;
};

const BreadcrumbDropdownClient = dynamic(
  () => import('./breadcrumbDropdownClient'),
  { ssr: false }
);

const BreadcrumbDropdown: React.FC<BreadcrumbDropdownProps> = (props) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      <div style={{ display: isMounted ? 'none' : 'block' }}>
        <details>
          <summary>{props.label}</summary>
          <ul>
            {props.items.map((item) => (
              <li key={item.key}>{item.label}</li>
            ))}
          </ul>
        </details>
      </div>

      <BreadcrumbDropdownClient {...props} />
    </>
  );
};

export default BreadcrumbDropdown;
